 

 import Nav from './Nav';
import Footer from './Footer';

function Contact() {
  return (
    <div className="App">
      <Nav />

      <main className="main-content">
        <section className="content-section">
          <div className="section-container">
            <h2>Contact Us</h2>
            <div className="contact-content">
                <h3><a href="mailto:nibbletapp@gmail.com">nibbletapp@gmail.com</a></h3>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Contact;